import {
  isDeprecatedVariableName,
  type DeprecatedVariables,
} from 'utils/variableValuePrimitives';
import {
  JOB_EXTERNAL_NAME_VARIABLE,
  JOB_INTERNAL_NAME_VARIABLE,
  JOB_NAME_VALUE_KEY,
  JOB_AI_NAME_VARIABLE,
  AI_NAME_VALUE_KEY,
  AI_NAME_LEGACY_KEY,
  JOB_HIRING_COMPANY_NAME_VARIABLE,
  COMPANY_NAME_VALUE_KEY,
  CANDIDATE_PHONE_NUMBER_VARIABLE,
  CANDIDATE_PHONE_NUMBER_VALUE_KEY,
  CANDIDATE_PHONE_LEGACY_KEY,
  CALL_INTERVIEW_LINK_VARIABLE,
  INTERVIEW_LINK_VALUE_KEY,
  CALL_ESTIMATED_DURATION_MINUTES_VARIABLE,
  ESTIMATED_DURATION_MINUTES_VALUE_KEY,
  CALL_EXPIRATION_DAYS_VARIABLE,
  EXPIRATION_DAYS_VALUE_KEY,
  CALL_RECRUITER_PHONE_NUMBER_VARIABLE,
  RECRUITER_PHONE_NUMBER_VALUE_KEY,
  FOLLOWUP_INTERVIEWER_NAME_VARIABLE,
  INTERVIEWER_NAME_VALUE_KEY,
  FOLLOWUP_INTERVIEWER_EMAIL_VARIABLE,
  INTERVIEWER_EMAIL_VALUE_KEY,
} from 'utils/variableValueKeys';

/**
 * The names `{{` autocomplete offers for a field: each deprecated name is dropped, and `job_name`
 * is offered as its canonical `job.external_name`. Validation still accepts the deprecated names.
 */
export const suggestedVariableNames = (
  names: readonly string[],
  deprecatedVariables: DeprecatedVariables | undefined
): string[] => [
  ...new Set(
    names
      .map((name) => {
        if (name === 'book_call' || name === 'custom_outro') {
          const canonical = `script.${name}`;
          return names.includes(canonical) ? canonical : '';
        }
        if (name === AI_NAME_VALUE_KEY || name === AI_NAME_LEGACY_KEY) {
          return JOB_AI_NAME_VARIABLE;
        }
        if (name === JOB_NAME_VALUE_KEY) {
          return JOB_EXTERNAL_NAME_VARIABLE;
        }
        if (name === 'job.name') {
          return JOB_INTERNAL_NAME_VARIABLE;
        }
        if (
          name === CANDIDATE_PHONE_NUMBER_VALUE_KEY ||
          name === CANDIDATE_PHONE_LEGACY_KEY
        ) {
          return CANDIDATE_PHONE_NUMBER_VARIABLE;
        }
        if (name === COMPANY_NAME_VALUE_KEY) {
          return JOB_HIRING_COMPANY_NAME_VARIABLE;
        }
        if (name === INTERVIEW_LINK_VALUE_KEY) {
          return CALL_INTERVIEW_LINK_VARIABLE;
        }
        if (name === ESTIMATED_DURATION_MINUTES_VALUE_KEY) {
          return CALL_ESTIMATED_DURATION_MINUTES_VARIABLE;
        }
        if (name === EXPIRATION_DAYS_VALUE_KEY) {
          return CALL_EXPIRATION_DAYS_VARIABLE;
        }
        if (name === RECRUITER_PHONE_NUMBER_VALUE_KEY) {
          return CALL_RECRUITER_PHONE_NUMBER_VARIABLE;
        }
        if (name === INTERVIEWER_NAME_VALUE_KEY) {
          return FOLLOWUP_INTERVIEWER_NAME_VARIABLE;
        }
        if (name === INTERVIEWER_EMAIL_VALUE_KEY) {
          return FOLLOWUP_INTERVIEWER_EMAIL_VARIABLE;
        }
        return name;
      })
      .filter(
        (name) =>
          name !== '' && !isDeprecatedVariableName(name, deprecatedVariables)
      )
  ),
];
